// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OnSdj","badges":"styles_badges__1-lIH"};